import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalHeader: {
    description: 'Title for modal allowing the seller to request to become a verified merchant',
    defaultMessage: 'Request: Become a Verified Merchant',
    id: 'z9ktiB',
  },
  instructions: {
    description: 'Title for modal allowing the seller to request to become a verified merchant',
    defaultMessage:
      'Fill in the requested details for our team to verify your account. Becoming a verified merchant will remove the ${limit} spending limit from your account.',
    id: 'Ny1l1Y',
  },
  afterEmailInstructions: {
    description: 'Instructions explaining what will happen after the user sends the email',
    defaultMessage:
      'You will receive a confirmation email once your account has been verified. Our team will contact you if we need additional information.',
    id: 'BDnWpN',
  },
  submitRequest: {
    description: 'Submit Request button',
    defaultMessage: 'Submit request',
    id: 'vt/Rl8',
  },
  commentLabel: {
    description: 'Placeholder for comments',
    defaultMessage: 'Additional Comments',
    id: 'kIf8V7',
  },
  websiteLabel: {
    description: 'Label for website input',
    defaultMessage: 'Website',
    id: 'iaTYPt',
  },
  somethingWentWrong: {
    description: 'Error message when something goes wrong',
    defaultMessage: 'Something went submitting your verification request. Please try again or check back later.',
    id: 'aXyygt',
  },
  somethingWrongTitle: {
    description: 'Title for error message when something goes wrong',
    defaultMessage: 'Verification Request Error',
    id: 'vkvBct',
  },
  successTitle: {
    description: 'Title for success message when verification request is successful',
    defaultMessage: 'Verification Request Successful',
    id: 'Hgi8dX',
  },
  successMessage: {
    description: 'Message for success message when verification request is successful',
    defaultMessage: 'Your request has been submitted. You will receive a confirmation email once your account has been verified.',
    id: 'q3kW0i',
  },
  close: {
    description: 'Close button',
    defaultMessage: 'Close',
    id: 'Px7S/2',
  },
  received: {
    description: 'Received',
    defaultMessage: 'Verification request received.',
    id: 'PLY4pI',
  },
  idvDescription: {
    defaultMessage:
      'Clicking "Verify with Plaid" will securely redirect you to Plaid, where you\'ll complete your identity verification in just a few simple steps. Once verified, you\'ll instantly unlock full access to your ShipStation Wallet, removing current spending limitations.',
    id: '8gcsc8',
    description: 'Describe Plaid and the process that the user will go through to verify their identity',
  },
  idvEmailCallToAction: {
    defaultMessage: "We've also sent a verification link to your email, in case you need to return and complete this process later.",
    id: 'tJ9hwT',
    description: 'Additional call to action via e-mail, if they need to return to the process later',
  },
  idvPlaidButton: {
    defaultMessage: 'Verify with Plaid',
    id: 'DyvOme',
    description: 'Button text for Plaid verification',
  },
  somethingWentWrongTitleIdv: {
    description: 'Title for IDV Session Failing to Start',
    defaultMessage: 'Failed to Launch Plaid',
    id: 'dYVDRI',
  },
  somethingWentWrongIdv: {
    description: 'Error message when something goes wrong with IDV request',
    defaultMessage: 'Something went wrong initiating your verification request with Plaid. Please try again later',
    id: 'OpUBH/',
  },
  auctanePayIdvHeader: {
    description: 'Title for Auctane Pay IDV modal',
    defaultMessage: 'Verify your Merchant Account with Plaid',
    id: 'QnhoK8',
  },
  idvPending: {
    description: 'Description for pending action',
    defaultMessage: "We're reviewing your request. We'll be in touch shortly.",
    id: 'yruVC3',
  },
});
